#wfcommit-spinner {
  font-size: 1rem;
  position: fixed;
  top: 1rem;
  right: 1rem;
  pointer-events: none;
}
